<template>
  <div>
    <div class="login-box bgf5">
      <div class="login">
        <el-tabs :value="'register'">
          <el-tab-pane label="用户注册" name="register">
            <el-form :model="register" :rules="regiRules" ref="register">
              <el-form-item prop="userName">
                <el-input v-model="register.userName" maxlength="20" placeholder="公司名称"></el-input>
              </el-form-item>
              <el-form-item prop="mobile">
                <el-input v-model="register.mobile" placeholder="手机号"></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input v-model="register.code" placeholder="图形验证码" maxlength="4"></el-input>
                <img-code></img-code>
                &nbsp;不区分大小写
              </el-form-item>
              <el-form-item prop="validate">
                <el-input v-model="register.validate" placeholder="短信验证码" maxlength="6"></el-input>
                <el-button type="primary" @click="send" :disabled="resetTime != 60">{{resetTime == 60 ? '获取验证码' : '获取（' + resetTime + '）'}}</el-button>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model="register.password" placeholder="设置密码" maxlength="20" show-password></el-input>
              </el-form-item>
              <el-form-item prop="confirmPassWord">
                <el-input v-model="register.confirmPassWord" placeholder="确认密码" maxlength="20" show-password></el-input>
              </el-form-item>
              <el-button class="flup" type="primary" @click="submit('register')">立即注册</el-button>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <div class="tip">已有账号？<span style="cursor: pointer;" @click="$router.push('/login')">立即登录</span></div>
      </div>
    </div>
  </div>
</template>

<script>
  import ImgCode from '@/components/img-code.vue'

  export default {
    components: {
      ImgCode
    },
    data() {
      return {
        resetTime: 60,
        register: {
          userName: '',
          mobile: '',
          code: '',
          validate: '',
          password: ''
        },
        regiRules: {
          userName: [
            { required: true,message: '昵称不能为空',trigger: 'blur' },
            { min: 4,max: 20,message: '昵称由数字，字母组成的4~10位文本',trigger: 'change' }
          ],
          mobile: [
            { required: true,message: '手机号不能为空',trigger: 'blur' },
            { min: 11,message: '手机号输入不正确',trigger: 'change' }
          ],
          validate: [
            { required: true,message: '短信验证码不能为空',trigger: 'blur' },
            { min: 6,message: '短信验证码长度不对',trigger: 'change' }
          ],
          password: [
            { required: true,message: '密码不能为空',trigger: 'blur' },
            { min: 6,max: 20,message: '密码长度在6-20位',trigger: 'change' }
          ],
          confirmPassWord: [
            { required: true,message: '密码不能为空',trigger: 'blur' },
            { min: 6,max: 20,message: '密码长度在6-20位',trigger: 'change' }
          ]
        }
      }
    },
    methods: {
      refreshTime() {
        const that = this;
        const resetInterval = setInterval(function(){
          if (that.resetTime == 0) {
            that.resetTime = 60;
            clearInterval(resetInterval);
          } else {
            that.resetTime--;
          }
        }, 1000)
      },
      send() {
        if (this.register.code == '') {
          this.$message.error('请先验证图形验证码');
        } else if (this.register.code.length != 4) {
          this.$message.error('图形验证码格式不正确');
        } else if (this.register.mobile == '') {
          this.$message.error('验证码要发给谁呢？');
        } else if (this.register.mobile.length != 11) {
          this.$message.error('手机号格式不正确');
        } else {
          this.$global.axios.post(this, '/sywl/user/message', {
            mobile: this.register.mobile,
            imgCode: this.register.code
          }, res => {
            this.refreshTime();
          })
        }
      },
      submit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$global.axios.post(this, '/sywl/user/register', this.register, res => {
              this.$message.success('注册成功，正在跳转...');
              this.$store.commit('loginChange', true);
              this.$router.push('/');
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  }
</script>

<style lang="scss">
  .login-box {
    padding: 82px 0;

    .login {
      position: relative;
      width: 680px;
      height: 702px;
      margin: 0 auto;
      padding: 73px 116px 86px 111px;
      background-color: #fff;
      border-radius: 4px;
      box-sizing: border-box;

      .el-tabs__nav {
        padding: 18px 0;
      }

      .el-tabs__item {
        font-size: 22px;
        color: #999;

        &.is-active {
          font-size: 28px;
          color: #333;
        }
      }

      .el-form-item {
        margin-bottom: 0;

        &__content {
          margin-top: 26px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          white-space: nowrap;

          .el-button {
            margin-top: 0;
            margin-left: 10px;
          }
        }
      }

      .el-checkbox {
        margin-top: 26px;
      }

      .el-button {
        margin-top: 26px;

        &.flup {
          width: 100%;
        }
      }

      .tip {
        position: absolute;
        bottom: 32px;
        left: 0;
        right: 0;
        font-size: 14px;
        color: #666;

        span {
          color: #1875f0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/register.vue